module.exports = __webpack_public_path__ + "img/logometavsec.5a594647.png";